import type { TransactionDistribution } from '@/models/transaction';

type DistributionLine = Pick<TransactionDistribution, 'amount' | 'account' | 'class' | 'associatedObjectType'>;

// A payer can be billed in several lines of one transaction (e.g. a captured preauth plus the remainder
// charged separately), so every matching line counts. Summed in cents to avoid floating point drift.
const sumAmounts = (distributions: DistributionLine[], isMatch: (distribution: DistributionLine) => boolean) => {
  const matching = distributions.filter(isMatch);
  if (!matching.length) {
    return undefined;
  }

  const cents = matching.reduce((total, distribution) => total + Math.round(distribution.amount * 100), 0);
  return Math.abs(cents) / 100;
};

/** Per-payer amounts of a transaction, as shown in the transaction tables (blank when there is no such line). */
export const getDistributionAmounts = (distributions: DistributionLine[]) => ({
  customerCredits: sumAmounts(distributions, (dist) => dist.associatedObjectType === 'Caller' && dist.class === 'L'),
  customerCharge: sumAmounts(distributions, (dist) => dist.associatedObjectType === 'Caller' && dist.account === 'Stripe'),
  partnerCredits: sumAmounts(distributions, (dist) => dist.associatedObjectType === 'Partner' && dist.class === 'L'),
  partnerCharge: sumAmounts(distributions, (dist) => dist.associatedObjectType === 'Partner' && dist.account === 'Stripe'),
  expiringCredits: sumAmounts(distributions, (dist) => dist.associatedObjectType === 'ExpiringCredit' && dist.class === 'L'),
});
